import TopBarLayout from "../../../components/TopBarLayout";
import ContentLayout from "../../../components/ContentLayout";
import { getDefaultSiteTitle, useTitle } from "../../../utils/hooks";

import { Box } from "@mui/material";

export default function ChatGPT() {
  useTitle(getDefaultSiteTitle());
  return <ChatGPTLayout />;
}
function ChatGPTLayout() {
  return (
    <>
      <TopBarLayout />
      <ContentLayout>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "30vh",
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          <p>coming soon ...</p>
        </Box>
      </ContentLayout>
    </>
  );
}
